module.exports = __webpack_public_path__ + "img/icon-empty.15f36506.png";